<template>
    <v-container fluid>
        <div class="bonus-details-box">
            <div class="bonus-header">Award Bonus: {{data.testId ? data.overAllInfo.testName : ""}}</div>
            <div>
                <v-row>
                    <v-col cols="12">
                        <v-select
                            ref="center"
                            v-model="selectedQuestion"
                            :items="questionList"
                            @change="getQuestion()"
                            label="Questions"
                            dense
                            hide-details
                            outlined
                        >
                            <template v-slot:selection="{ item }">
                                <span>{{ item.text }}</span>
                            </template>

                            <template v-slot:item="{ item }">
                                <div  class="question-details" :title="item.text">
                                    <div>
                                        {{ item.text }}
                                    </div>
                                </div>
                            </template>
                        </v-select>
                    </v-col>
                    <v-col cols="12">
                        <QuestionDetailTypes
                            v-if="
                                questionDetails &&
                                questionDetails.currentQuestion
                            "
                            :data="questionDetails"
                        />
                    </v-col>
                    <v-col cols="12">
                        <div class="d-flex justify-start">
                            <v-btn class="cust-btn btn-uppercase" color="primary" @click="rewardBonus()" >Award Bonus</v-btn >
                            <v-btn class="mx-4" color="secondary" @click="onClose({ status: false })" >
                                Cancel
                            </v-btn >
                        </div>
                    </v-col>
                </v-row>
            </div>
        </div>
    </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import QuestionDetailTypes from "@/components/student/QuestionDetailTypes.vue";

export default {
    name: "ResetPassword",
    props: ["onClose", "status", "data"],
    components: {
        QuestionDetailTypes,
    },
    data() {
        return {
            questionList: [],
            selectedQuestion: null,
            questionTypes: {},
            questionDetails: null,
        };
    },
    mounted() {
        this.questionTypes = this.QUE_TYPES;
        this.getQuestionsList();
    },
    computed: {},
    methods: {
        ...mapActions({
            getQuestions: "testStore/getQuestions",
            applyBonus: "testStore/applyBonus",
            getQuestionDetails: "resultStore/getQuestionDetails",
        }),
        rewardBonus() {
            let postData = {
                test_detail_id: this.selectedQuestion.testDetailId,
                schedule_id: this.data.scheduleId,
            };
            this.$root.showLoader = true;
            this.applyBonus(postData)
                .then((response) => {
                    this.$root.showLoader = false;
                    this.$toasted.success("Bonus Rewarded Successfully.");
                })
                .catch((err) => {
                    this.$root.showLoader = false;
                    this.$toasted.error(
                        "Error rewarding bonus. Please try again"
                    );
                });
        },
        getQuestion() {
            let postData = {
                test_detail_id: this.selectedQuestion.testDetailId,
				studentId: parseInt(this.data.overAllInfo.studentId)
            };
            this.getQuestionDetails(postData)
                .then((response) => {
                    let question = {};
                    question.question_details = response.question_details;
                    let processedQuestion = this.processQuestion(question);
                    question.currentQuestion = processedQuestion;
                    question.currentQuestion.questionNo = this.selectedQuestion.questionNo;
                    question.showAnswerField = true;
                    this.questionDetails = question;
                })
                .catch((err) => {
                    this.$toasted.error(
                        "Error getting question Details. Please try again"
                    );
                });
        },
        getQuestionsList() {
            let reqData = {
                test_id: this.data.testId,
            };
            this.getQuestions(reqData)
                .then((response) => {
                    this.questionList = response.map((q) => {
                        let question = { text: "", value: {} };
                        question.text =
                            "Q. " +
                            q.index +
                            ", Subject: " +
                            q.question_details.chapter_details.subject_details
                                .title +
                            ", Chapter: " +
                            q.question_details.chapter_details.title;
                        question.value = {
                            testDetailId: q.test_detail_id,
                            questionNo: q.index,
                        };
                        return question;
                    });
                })
                .catch((err) => {
                    this.$toasted.error("Error getting list of questions.");
                });
        },
        processQuestion(questionData) {
            let q = questionData.question_details; // current question in loop
            let questionTypeId = q.question_type;
            questionTypeId =
                questionTypeId == this.questionTypes.COMPREHENSION ||
                questionTypeId == this.questionTypes.TC
                    ? q.subtype.id ?q.subtype.id :q.subtype
                    : q.question_type;
            let currentQuestion = {};
            currentQuestion = this.generateQuestionObject(questionTypeId, q);
            currentQuestion.subtype = q.subtype ? q.subtype.id ?q.subtype.id :q.subtype:'';
            if (
                q.question_type == this.questionTypes.COMPREHENSION ||
                q.question_type == this.questionTypes.TC
            ) {
                currentQuestion.passage = q.passage;
            }
            return currentQuestion;
        },
        generateQuestionObject(typeId, q) {
            let type = "";
            type = this.getQuestionType(typeId);
            let currentQuestion = {};
            currentQuestion = this.getCurrentQuestionCommonKeys(
                currentQuestion,
                q
            );
            let cqr = null;
            switch (type) {
                case 1:
                    // cqr - currentQuestionResult
                    cqr = this.getCQRType1(typeId, q);
                    currentQuestion.options = cqr.options;
                    currentQuestion.correctAnswer = cqr.correctAnswer;
                    break;
                case 2:
                    cqr = this.getCQRType2(q);
                    currentQuestion.correct_answer = cqr.correctAnswer;
                    currentQuestion.correctAnswer = cqr.correctAnswer;
                    break;
                case 3:
                    cqr = this.separateOptions(q, 1);
                    currentQuestion.options_abc = cqr.options_abc;
                    currentQuestion.options_pqr = cqr.options_pqr;
                    currentQuestion.correctAnswer = cqr.correctAnswer;
                    break;
                case 4:
                    cqr = this.separateOptions(q, 2);
                    currentQuestion.options_abc = cqr.options_abc;
                    currentQuestion.options_pqr = cqr.options_pqr;
                    currentQuestion.options = cqr.op;
                    currentQuestion.correctAnswer = cqr.correctAnswer;

                    break;
                case 6:
                    cqr = this.getCQRType2(q);
                    currentQuestion.correct_answer = cqr.correctAnswer;
                    currentQuestion.startValue = cqr && cqr.correctAnswer ? cqr.correctAnswer.split(
                        "##"
                    )[0] : '';
                    currentQuestion.endValue = cqr && cqr.correctAnswer ? cqr.correctAnswer.split("##")[1] : '';
                    currentQuestion.correctAnswer = cqr.correctAnswer;
                    break;
            }
            return currentQuestion;
        },
        getQuestionType(id) {
            if (
                id == this.questionTypes.ASSERTION_REASON ||
                id == this.questionTypes.MULTIPLE_CORRECT ||
                id == this.questionTypes.SINGLE_CORRECT ||
                id == this.questionTypes.COMPREHENSION_2Q_SA ||
                id == this.questionTypes.COMPREHENSION_2Q_MM ||
                id == this.questionTypes.COMPREHENSION_2Q_MA ||
                id == this.questionTypes.COMPREHENSION_3Q_SA ||
                id == this.questionTypes.COMPREHENSION_3Q_MA ||
                id == this.questionTypes.TC_2Q_SA ||
                id == this.questionTypes.TC_3Q_SA
            ) {
                return 1;
            } else if (id == this.questionTypes.INTEGER) {
                return 2;
            } else if (id == this.questionTypes.MATRIX_MATCH) {
                return 3;
            } else if (id == this.questionTypes.MATRIX_MATCH_OPTION) {
                return 4;
            } else if (
                id == this.questionTypes.COMPREHENSION ||
                id == this.questionTypes.TC
            ) {
                return 5;
            } else if (id == this.questionTypes.SUBJECTIVE || id == this.questionTypes.COMPREHENSION_2Q_NU|| id == this.questionTypes.SUBJECTIVEINTEGER) {
                return 6;
            }
        },
        getCurrentQuestionCommonKeys(currentQuestion, q) {
            currentQuestion.id = q.id;
            currentQuestion.questionNo = q.index;
            currentQuestion.question_text = q.question_text;
            currentQuestion.question_type = q.question_type;
            currentQuestion.questionType = { id: q.question_type };
            currentQuestion.parent_id = q.parent_id;
            currentQuestion.section_id = q.section_id;
            currentQuestion.test_detail_id = q.test_detail_id;
            currentQuestion.correct_marks = q.marks;
            currentQuestion.negative_marks = q.negative_marks;
            currentQuestion.partial_marking = q.partial_marking;
            currentQuestion.solution = q.solution;
            currentQuestion.hints = q.hints;
            currentQuestion.userSelectedAnswer = q.user_selected_answer;
            currentQuestion.isAnswered = false; // to know if the current question is answered.
            currentQuestion.disabled = true;
            currentQuestion.showAnswerField = true;

            return currentQuestion;
        },
        getCQRType1(type, q) {
            let responseData = {
                options: q.options,
                correctAnswer: "",
            };
            let correctOptions = _.cloneDeep(q.options);
            let correctAnswer = [];
            correctOptions.forEach((o) => {
                if (parseInt(o.correct_answer)) {
                    correctAnswer.push(o.index);
                }
            });

            responseData.correctAnswer = correctAnswer.join(", ");
            return responseData;
        },
        getCQRType2(q) {
            let responseData = {
                correctAnswer: q.correct_answer,
            };
            return responseData;
        },
        separateOptions(q, type) {
            let options = q.options;
            let op = [];
            let options_abc = [];
            let options_pqr = [];

            let correctAnswer = [];

            options.forEach((option) => {
                // separate options: options (op), options_abc, options_pqr
                if (option.column == 1) {
                    option.correct_answer = option.correct_answer
                        ? option.correct_answer
                        : "";
                    options_abc.push(option);
                } else if (option.column == 2) options_pqr.push(option);
                else {
                    option.correct_answer = option.correct_answer
                        ? option.correct_answer
                        : false;
                    op.push(option);
                }
            });

            // get correct answer
            if (type == 2) {
                // matrix match options
                op.forEach((o, idx) => {
                    if (parseInt(o.correct_answer)) {
                        correctAnswer.push(o.index);
                    }
                });
            }
            if (type == 1) {
                // matrix match
                options_abc.forEach((o, idx) => {
                    if (o.correct_answer > "") {
                        correctAnswer.push({
                            index: o.index,
                            value: o.correct_answer,
                        });
                    }
                });
            }

            if (type == 1) {
                // type = 1 : matrix match

                let ca = correctAnswer.map((answer) => {
                    let ans = answer.index + ": " + answer.value;
                    return ans;
                });
                ca = ca.join(", ");
                correctAnswer = ca;
            } else if (type == 2) {
                // type = 2 : matrix match options
                correctAnswer = correctAnswer.join(", ");
            }

            return {
                op,
                options_abc,
                options_pqr,
                correctAnswer,
            };
        },
    },
    watch: {
        "data.testId": function () {
            this.questionList = [];
            this.selectedQuestion = null;
            this.questionDetails = null;
            if (this.data.testId) {
                this.getQuestionsList();
            }
        },
    },
};
</script>
